import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';

export const PoliticaPrivacidad = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="py-20">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="text-4xl md:text-5xl font-bold text-[#004534] mb-8 text-center">
            POLÍTICA DE PRIVACIDAD
          </h1>
          
          <div className="bg-gray-50 rounded-3xl p-8 md:p-12 shadow-lg">
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#004534] mb-4">
                1. Responsable del tratamiento
              </h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                <li><strong>Responsable:</strong> Emilio José Bautista Santiago (ERBA Service)</li>
                <li><strong>Correo electrónico:</strong> info@erbaservice.com</li>
                <li><strong>Dirección:</strong> Calle Ntra. Señora de las Nieves, Edificio Piscis Local 4, C.P. 29770 Torrox (Málaga)</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#004534] mb-4">
                2. Finalidad del tratamiento
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Los datos personales que se recogen a través de los formularios de contacto o correo 
                electrónico serán tratados con las siguientes finalidades:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                <li>Gestionar solicitudes de información o presupuestos.</li>
                <li>Mantener comunicación comercial con clientes y potenciales clientes.</li>
                <li>Cumplir con las obligaciones legales derivadas de la prestación de servicios.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#004534] mb-4">
                3. Legitimación del tratamiento
              </h2>
              <p className="text-gray-700 leading-relaxed">
                La base legal para el tratamiento de los datos es el consentimiento del interesado y, 
                en su caso, la ejecución de un contrato o obligaciones legales.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#004534] mb-4">
                4. Conservación de los datos
              </h2>
              <p className="text-gray-700 leading-relaxed">
                Los datos se conservarán durante el tiempo necesario para cumplir la finalidad por la 
                que se recabaron y mientras existan responsabilidades legales derivadas de los servicios prestados.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#004534] mb-4">
                5. Cesión de datos a terceros
              </h2>
              <p className="text-gray-700 leading-relaxed">
                No se cederán datos a terceros salvo obligación legal o cuando sea necesario para la 
                correcta prestación del servicio (por ejemplo, proveedores de alojamiento web o 
                mantenimiento técnico con acceso restringido).
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-[#004534] mb-4">
                6. Derechos de los usuarios
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                El usuario puede ejercer en cualquier momento sus derechos de acceso, rectificación, 
                supresión, oposición, limitación y portabilidad enviando un correo electrónico a 
                info@erbaservice.com, acreditando su identidad.
              </p>
              <p className="text-gray-700 leading-relaxed">
                Asimismo, tiene derecho a presentar una reclamación ante la Agencia Española de 
                Protección de Datos (AEPD) si considera que el tratamiento no se ajusta a la normativa vigente.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-[#004534] mb-4">
                7. Seguridad de los datos
              </h2>
              <p className="text-gray-700 leading-relaxed">
                ERBA Service aplica las medidas técnicas y organizativas necesarias para garantizar la 
                seguridad y confidencialidad de los datos personales tratados, evitando su alteración, 
                pérdida o acceso no autorizado.
              </p>
            </section>
          </div>

          <div className="text-center mt-8">
            <button 
              onClick={() => window.history.back()}
              className="bg-[#16a34a] hover:bg-[#15803d] text-white px-8 py-3 rounded-full font-semibold transition-all"
            >
              Volver
            </button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};